module.exports = __webpack_public_path__ + "name=img/src/assets/emoji/hat.png?fdff033668a0be528442b1f1d65c849f";